import { shortRootGetter } from '../../../../utils/vuex'

export default {
  myUid: shortRootGetter('account/myUid'),
  getUser: shortRootGetter('laxin/getUser'),

  awardId(state) {
    return state.awardId > 0 ? +state.awardId : 0
  },

  giveUid(state) {
    const { curAward } = state
    return curAward && curAward.gUid > 0 ? curAward.gUid : 0
  },
  takeUid(state) {
    const { curAward } = state
    return curAward && curAward.takeUid > 0 ? curAward.takeUid : 0
  },
  giveUser(_, getters) {
    return getters.getUser(getters.giveUid)
  },
  takeUser(_, getters) {
    return getters.getUser(getters.takeUid)
  },
  isGiver(_, getters) {
    const { myUid, giveUid } = getters
    return myUid > 0 && +myUid === giveUid
  }
}
